// extracted by mini-css-extract-plugin
export default {"tabs":"re9O1Yk","tablist":"sIb8HCy","s200":"miofBT4","button":"w5QUBxJ","s300":"IZ64UvG","stretch":"bis4rUb","active":"UgdpuQ6","panel":"NFTYXzJ"};